import { Component, OnInit } from '@angular/core';
import { OrderService, AuthenticationService, ScriptService } from '@app/core';
import { Order } from '@core/model/order.model';
import { Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { Paginated } from '@app/core/model/paginated.model';
import { finalize } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';

declare let pdfMake: any;

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.css']
})
export class OrderListComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
